import script from "./BaseSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSidebar.vue?vue&type=style&index=0&id=e71de5e4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e71de5e4"]])

export default __exports__